module.exports = __webpack_public_path__ + "img/d1579a4780b873faa1994ac4b70d21ae.5d2dc5a8.png";